export default __webpack_public_path__ + "a42c341cba008bd51341e14599a32885.jpg";